<template>
    <v-container fluid fill-height>
        <v-layout v-if="loading" align-center justify-center>
            <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>
        <v-layout v-else>
            <v-flex>
                <v-card>
                    <v-layout>
                       <ScoutingManagement></ScoutingManagement>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
 
import ScoutingManagement from '@/components/scout/ScoutingManagement.vue'
export default {
    data() {
        return {
            loading: false
        }
    },
    computed: {
        selectedPlant: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedPlant;
            },
            set(value) {
                this.$store.commit("PestAndDiseaseStore/setSelectedPlant", value);
            }
        }
    },
    methods: {
        
    },
    async created() {
        if (!this.selectedPlant) {
            this.loading = true;

            await this.$store.dispatch("PestAndDiseaseStore/loadLocations");

            this.loading = false;
        } else {
            // Do not await but load in the background
            this.$store.dispatch("PestAndDiseaseStore/loadLocations");
        }
    },
    components: {
        ScoutingManagement: ScoutingManagement
    }
}
</script>

<style>

</style>
